module.exports = __webpack_public_path__ + "static/PACE Ecosystem-4851b785bfe5737043a6b8cbe2a80275.png";